/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import ErrorComponent from "@/components/error";
export default function Error(param) {
    let {} = param;
    return /*#__PURE__*/ _jsx(ErrorComponent, {});
}
